module.exports = __webpack_public_path__ + "components/country-flag/static/il-e407f6e35a5c4561300cfe8e836ecafe.svg";